document
  .querySelectorAll('.link-fancy')
  .forEach(link => {  
    const circle = link.querySelector('.circle')

    link.addEventListener('mouseover', () => circle.style.strokeDasharray = '250% 500px')
    link.addEventListener('mouseleave', () => circle.style.strokeDasharray = '0 500px')
    link.addEventListener('touchstart', () => circle.style.strokeDasharray = '250% 500px')
    link.addEventListener('touchend', () => circle.style.strokeDasharray = '0 500px')
  })